import emitter from "@/emitter";
import _ from "lodash";
const AuditionAudioMixin = {

	data() {
		return {
			auditionAudioMenu: {
				open: false,
				activator: null
			},
			channelNumber: null
		}
	},

	methods: {
		openAuditionAudioWidget(ev, asset, sourceComponentId) {
			if (!this.auditionAudioMenu.open && _.isEqual(this.asset, asset)) {
				if (ev) {
					emitter.emit("open-audio-widget", ev);
				}

				this.auditionAudioMenu.open = true;
				this.auditionAudioMenu.activator = this.$el;

				if (!asset?.AuditionAudioUrl) {
					this.$store.dispatch("getAssetAudioUrl", asset).then(response => {
						if (response.status === 200) {
							if (!sourceComponentId || sourceComponentId === "log-list") {
								asset["AuditionAudioUrl"] = response.data.url;
							}
							else {
								this.$store.commit(
									"UPDATE_LIBRARY_ASSET",
									{assetId: asset.AssetID, data: {AuditionAudioUrl: response.data.url}}
								);
							}
							this.$nextTick(() => {
								this.$refs.auditionAudioWidget?.initWaveform(response.data.url);
							});
						}
						else {
							this.$store.commit(
								"SHOW_NOTIFICATION_WITH_TYPE",
								{message: "An error occurred when trying to load the asset's audio."}
							)
						}
					}).catch(() => {
						this.$store.dispatch("getAssetPartialAudio", asset)
							.then(response => {
								const audioBuffer = response.data;
								if (!sourceComponentId || sourceComponentId === "log-list") {
									asset["AuditionAudioUrl"] = audioBuffer;
								}
								else {
									this.$store.commit(
										"UPDATE_LIBRARY_ASSET",
										{assetId: asset.AssetID, data: {AuditionAudioUrl: audioBuffer}}
									);
								}
								this.$nextTick(() => {
									this.$refs.auditionAudioWidget?.initWaveform(audioBuffer);
								});
							})
							.catch(() => {
								this.$store.commit(
									"SHOW_NOTIFICATION_WITH_TYPE",
									{message: "An error occurred when trying to load the asset's audio."}
								);
							});
					});
				}
				else {
					this.$nextTick(() => {
						this.$refs.auditionAudioWidget.initWaveform(asset.AuditionAudioUrl);
					});
				}
			}
		},

		closeDialog() {
			this.deleteDialog = false;
			this.contextMenu = false;
		},

		closeAuditionAudioWidget() {
			this.auditionAudioMenu.open = false;
		}
	},

	mounted() {
		// Check if another audio widget is open and close it
		emitter.on("open-audio-widget", (ev) => {
			if (!this.$el.contains(ev.target) && this.auditionAudioMenu.open) {
				this.$refs.auditionAudioWidget.stopAudioWaveform();
			}
		});
	},

	beforeDestroy() {
		emitter.off("open-audio-widget");
	}
}

export default AuditionAudioMixin;